// extracted by mini-css-extract-plugin
module.exports = {"ComponentBodyProse":"ComponentBodyProse_ComponentBodyProse__nlR5d"};